import { useState, useEffect } from "react";
import { ImgLoader, Loader, SpeakerModal } from "./index";
import { getData } from "../utils/apiCalls";
import { tracking } from "../utils/tracking";
import { svgs } from "../assets/svgs";
import speakers_dyn from '../data/speakers_dyn_overview.json'
import speakers_dyn_overview from '../data/speakers_dyn_overview.json'

export const SpeakerCards = ({ isSliced }) => {
   const [data, setData] = useState({})
   const [speakerIdx, setSpeakerIdx] = useState(null)
   const [isLoading, setIsLoading] = useState(true)
   const [numOfSpeakersToDisplay, setNumOfSpeakersToDisplay] = useState(isSliced ? 20 : Infinity);

   useEffect(() => {
      // getData(`https://youngstartup.io/api/cwebsite/get_speakers_dyn?${isSliced && 'sc=true'}`)
      //    .then(res => { setData(res) })
      //    .then(() => { setIsLoading(false) })
      if (isSliced) setData(speakers_dyn_overview)
      else setData(speakers_dyn)
   }, [isSliced])

   useEffect(() => {
   }, [numOfSpeakersToDisplay])
   const handleClose = () => setSpeakerIdx(null);
   const addMoreSpeakersToDisplay = () => {
      setNumOfSpeakersToDisplay(prev => prev + 20)
   }

   return (
      <div className='speaker-cards-container' >
         <div className='speaker-cards' >
            {/* {isLoading && <Loader color='dark1' />} */}
            { data?.speakers?.length > 0 &&
               <h1>
                  {data?.current_speakers ? `OUR FIRST ` + (data.total_display >= 50 ? data.total_display : "") + ` FEATURED INVESTORS` : 'FEATURED INVESTORS FROM THE RECENT SUMMIT'}
               </h1>
            }
            { data?.speakers?.length > 0 &&
               <div className="speaker-card-container">
                  {
                     data?.speakers?.slice(0, numOfSpeakersToDisplay).map((speaker, i) =>
                        <div className="speaker-card"
                           key={i}
                           onClick={() => {
                              setSpeakerIdx(i)
                           }}
                        >
                           <ImgLoader src={speaker.speaker_head_shot_to_display} placeHolder={svgs.headshotPLaceholder} />
                           <h3>{speaker.firstname} {speaker.lastname}</h3>
                           <h4>{speaker.company}</h4>
                        </div>
                     )
                  }
               </div>
            }
            {
               isSliced && data?.total > 0 && numOfSpeakersToDisplay < data?.total &&
               <div className="btn-container">
                  <button onClick={() => { tracking(274); addMoreSpeakersToDisplay() }} className='btn' >
                     Show More
                  </button>
               </div>
            }
            {/* {data?.total > 0 && numOfSpeakersToDisplay >= data?.total && <h2>More Investors to be Announced</h2>} */}
            {
               speakerIdx !== null &&
               <div className="modal-container" >
                  <div className="speakere-modal" >
                     <SpeakerModal speakers={data?.speakers} speakerIdx={speakerIdx} handleClose={handleClose} />
                  </div>
               </div>
            }
         </div >
      </div >
   )
}